import React from 'react';
import PropTypes from 'prop-types';
import { InfoTextWrapper, InfoLabel, InfoText } from '../../styled';

const ClaimIDInfo = ({ eobNumber }) => {
  return (
    <InfoTextWrapper>
      {!eobNumber && <InfoLabel>Claim ID </InfoLabel>}
      <InfoText>{eobNumber || '-'}</InfoText>
    </InfoTextWrapper>
  );
};

ClaimIDInfo.propTypes = {
  eobNumber: PropTypes.string
};

export default ClaimIDInfo;
